@if (landingPage.custom) {
  <div class="landing-page common__body-container">
    <header-landing [configuration]="landingPage.custom"></header-landing>
    <div class="landing-page__body">
      <div class="landing-page__container">
        <div class="landing-page__header-container">
          <div class="landing-page__title-container">
            <div class="landing-page__title-header-container">
              <div class="landing-page__title-container-text">
                <span-tooltip
                  class="landing-page__title-text landing-page__desktop"
                  [text]="(landingPage.concept?.titlePrefix && skin === 'icam-red' && !landingPage.showProcedure && !landingPage.showConceptUserProfile && landingPage.showButtonNewQuery) ? landingPage.concept?.titlePrefix + ' / ' + landingPage.titleShared : landingPage.titleShared">
                </span-tooltip>
                <span class="landing-page__title-text landing-page__tablet">
                  {{(landingPage.concept?.titlePrefix && skin === 'icam-red' && !landingPage.showProcedure && !landingPage.showConceptUserProfile && landingPage.showButtonNewQuery) ? landingPage.concept?.titlePrefix + ' / ' + landingPage.titleShared : landingPage.titleShared}}
                </span>
              </div>
              @if (landingPage.task?.taskId) {
                <div class="landing-page__date-alert-header-container landing-page__desktop">
                  <div class="common-tag__neutral-light">
                    <span class="common-tag__neutral-label-text">
                      <span [afTranslate]="'landing-page.created-by'">Creada por  </span>
                      <span> {{landingPage.userLogin}}</span>
                      <span> {{landingPage.creationDate | convertDate:'without-time'}} </span>
                    </span>
                  </div>
                  @if (landingPage.taskExpirated >= 1 && landingPage.task && ['Resuelta', 'Cerrada', 'Cerrada sin resolver'].indexOf(landingPage.task.state) === -1) {
                    <i class="lf-icon-notification common-special-icon__notification-md"
                      pTooltip="{{('task-edit.task-has-expired' | afTranslate)}} {{landingPage.taskExpirated}} {{landingPage.dayText}}"
                      tooltipPosition="top">
                      <span class="common-special-icon__dot-md-notification"></span>
                    </i>
                  }
                </div>
                @if (landingPage.task?.taskTypeId === 3) {
                  <button class="common-button__text-border landing-page__desktop"
                    (click)="editConcept()">
                    <span class="common-button__text-title"
                      [afTranslate]="'landing-page.concept-access'">Acceder al concepto</span>
                  </button>
                  <button class="common-button__icon-xl-border landing-page__tablet"
                    (click)="editConcept()">
                    <i class="lf-icon-forms common-icon__lg"></i>
                  </button>
                }
              }@else if (landingPage.showButtonsHeader) {
                <div class="landing-page__buttons-header-container">
                  @if (landingPage.conceptSelected?.poll && landingPage.conceptSelected?.pollExpirationDate && !landingPage.showProcedure) {
                    <div class="common-tag__neutral-light landing-page__desktop">
                      <span class="common-tag__neutral-label-text">
                        <span [afTranslate]="'expanded-menu.expiration-period'">Plazo de expiración </span>
                        <span> {{landingPage.conceptSelected?.pollExpirationDate | convertDate:'without-time'}} </span>
                      </span>
                    </div>
                  }
                  @if (landingPage.conceptSelected?.description && !landingPage.conceptSelected?.poll) {
                    <button class="common-button__icon-lg-noborder landing-page__desktop"
                      (click)="showConceptInfo()">
                      <i class="lf-icon-information common-icon__md"></i>
                    </button>
                  }
                  <!-- @if ((!task && (!public || isMonitoring) && !landingPage.showProcedure && !landingPage.showConceptUserProfile && (skin === 'icam-red' && landingPage.showButtonNewQuery)) || landingPage.conceptSelected?.poll) { -->
                  @if ((!task && (!public || isMonitoring) && landingPage.conceptSelected?.conceptObjectId && !landingPage.showProcedure && !landingPage.showConceptUserProfile) || landingPage.conceptSelected?.poll) {
                    <button class="common-button__icon-lg-noborder"
                      [ngClass]="{'landing-page__desktop': !landingPage.conceptSelected?.poll}"
                      (click)="printConcept()">
                      <i class="lf-icon-print common-icon__md"></i>
                    </button>
                  }
                  @if (landingPage.showButtonUserProfile && !landingPage.showConceptUserProfile) {
                    <button class="common-button__text-border landing-page__desktop"
                      [disabled]="landingPage.disabledButtonsHeader"
                      (click)="showUserProfile()">
                      <span class="common-button__text-title"
                        [afTranslate]="'result-search.user-profile'">Perfil de usuario</span>
                    </button>
                  }
                  @if (landingPage.showButtonProcedures && !landingPage.showProcedure) {
                    <button class="common-button__text-border landing-page__desktop"
                      [disabled]="landingPage.disabledButtonsHeader"
                      (click)="showProcedures()">
                      <span class="common-button__text-title">{{landingPage.proceduresText}}</span>
                    </button>
                  }
                  @if (skin === 'icam-red' && landingPage.showButtonNewQuery) {
                    <button class="common-button__icon-xl"
                      [disabled]="landingPage.disabledButtonsHeader"
                      [pTooltip]="'landing-page.create-new-query' | afTranslate"
                      (click)="createNewQuery()">
                      <i class="lf-icon-add-round common-icon__lg"></i>
                    </button>
                  }
                </div>
                @if (!landingPage.conceptSelected?.poll && (landingPage.showButtonProcedures || landingPage.showButtonUserProfile || (!task && (!public || isMonitoring) && !landingPage.showProcedure) || landingPage.conceptSelected?.description)) {
                  <button-with-menu-action class="landing-page__tablet landing-page__tablet--action-menu"
                    [item]="landingPage.headerOptions"
                    (configureMenuEmitter)="openHeaderAction()"
                    (launchActionEmitter)="launchHeaderAction($event.action)"></button-with-menu-action>
                }
              }
            </div>
            <div class="landing-page__second-line-title-container landing-page__tablet">
              @if (landingPage.conceptSelected?.poll && landingPage.conceptSelected?.pollExpirationDate && !landingPage.showProcedure) {
                <div class="common-tag__neutral-light">
                  <span class="common-tag__neutral-label-text">
                    <span [afTranslate]="'expanded-menu.expiration-period'">Plazo de expiración </span>
                    <span> {{landingPage.conceptSelected?.pollExpirationDate | convertDate:'without-time'}} </span>
                  </span>
                </div>
              }
              @if (landingPage.task?.taskId) {
                <div class="common-tag__neutral-light">
                  <span class="common-tag__neutral-label-text">
                    <span [afTranslate]="'landing-page.created-by'">Creada por  </span>
                    <span> {{landingPage.userLogin}}</span>
                    <span> {{landingPage.creationDate | convertDate:'without-time'}} </span>
                  </span>
                </div>
                @if (landingPage.taskExpirated >= 1) {
                  <div class="common-tag__new">
                    <span class="common-tag__new-bullet"></span>
                    <span class="common-tag__new-label-text">
                      <span [afTranslate]="'task-edit.task-has-expired'">La tarea ha vencido hace </span>
                      <span>{{landingPage.taskExpirated}} {{landingPage.dayText}}</span>
                    </span>
                  </div>
                }
              }
            </div>
          </div>
          @if (!landingPage.showProcedure && landingPage.dataHeader?.customBreadcrumbs && !landingPage.concept?.poll) {
            <div class="common-breadcrumb__container">
              <div class="common-breadcrumb__container-all-breadcrumbs">
                <button class="common-breadcrumb__button-home"
                  [disabled]="true">
                  <i class="lf-icon-map-marker common-icon__md"></i>
                </button>
                <div class="common-breadcrumb__container-breadcrumbs"
                  id="evaluationHeaderBreadcrumbs">
                  @for (breadcrumb of landingPage.dataHeader?.customBreadcrumbs; track $index) {
                    <div class="common-breadcrumb__container-element-breadcrumb"
                      [ngClass]="$last?'common-breadcrumb__container-element-breadcrumb--with-action':'landing-page__desktop'"
                      [id]="$index">
                      <span-tooltip class="common-breadcrumb__label-text-breadcrumb common-breadcrumb__label-text-breadcrumb--disabled landing-page__desktop"
                        [ngClass]="{'common-breadcrumb__label-text-breadcrumb--selected': $last}"
                        [text]="breadcrumb"></span-tooltip>
                      <span class="common-breadcrumb__label-text-breadcrumb common-breadcrumb__label-text-breadcrumb--disabled common-breadcrumb__label-text-breadcrumb--selected landing-page__tablet">{{breadcrumb}}</span>
                      @if (!$last) {
                        <span class="common-breadcrumb__icon-arrow">&gt;</span>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
        @if (!landingPage.showProcedure) {
            @if (landingPage.task?.taskId && landingPage.showTask) {
              <task-edit-custom
                [taskSelect]="landingPage.task"
                [concept]="landingPage.conceptTask">
              </task-edit-custom>
            }@else if (landingPage.conceptSelected) {
              @if (!landingPage.showConceptUserProfile) {
                @if (!landingPage.conceptSelected.sequentialView) {
                  <concept-form-custom
                    [concept]="landingPage.conceptSelected"
                    [published]="concept.publicShared"
                    [evaluationId]="landingPage.dataHeader?.evaluationId"
                    [footerConceptPublic]="landingPage.footerConceptPublic"
                    [formalitiesList]="landingPage.concept?.list"
                    [disabledSave]="landingPage.disabledButtonsHeader"
                    [lockComToManager]="landingPage.lockComToManager"
                    (launchAction)="launchAction($event)">
                  </concept-form-custom>
                }@else{
                  <concept-form-sequential class="landing-page__container-centered"
                    [concept]="landingPage.conceptSelected"
                    [public]="public"
                    [evaluationId]="landingPage.dataHeader?.evaluationId"
                    [footerConceptPublic]="landingPage.footerConceptPublic"
                    [formalitiesList]="landingPage.concept?.list"
                    [disabledSave]="landingPage.disabledButtonsHeader"
                    (launchAction)="launchAction($event)">
                  </concept-form-sequential>
                }
              }@else if (landingPage.conceptUserProfile) {
                <concept-form-custom
                  [concept]="landingPage.conceptUserProfile"
                  [published]="concept.publicShared"
                  [evaluationId]="landingPage.dataHeader?.evaluationId"
                  [footerConceptPublic]="landingPage.footerConceptPublic"
                  [lockComToManager]="landingPage.lockComToManager"
                  (launchAction)="launchAction($event)">
                </concept-form-custom>
              }
            }
          <!-- } -->
        }@else {
          <concept-list-landing
            [list]="landingPage.concept?.list"
            [showList]="landingPage.showProcedure"
            [proceduresText]="landingPage.proceduresText">
          </concept-list-landing>
          <div class="concept-form__footer">
            <div class="concept-form__footer-buttons-auto">
              <button (click)="goBack()">
                <span
                  afTranslate="common.return"
                  class="common-button__text-title">
                  _Volver
                </span>
              </button>
            </div>
          </div>
        }
      </div>
    </div>
    <customize-footer [configureOptions]="landingPage.custom"></customize-footer>
  </div>
}
